// src/components/Hero.tsx
import React from "react";

const Hero: React.FC = () => {
  const scrollToForm = () => {
    const el = document.getElementById("formulario");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="inicio" className="hero">
      <div className="container">
        <h1>Buscamos Hogares en el Campo</h1>
        <p>
          Queremos salir del bullicio urbano para criar nuestra familia en un
          entorno natural. Si tienes una casa rural, ¡sube tus datos y fotos
          para que construyamos juntos un futuro aquí!
        </p>
        <button className="cta-button" onClick={scrollToForm}>
          Cuéntanos tu historia
        </button>
      </div>
    </section>
  );
};

export default Hero;
